<refx-basic-layout>
  <div messagePanel>
    <refx-messages-panel-cont class="error-message-panel"
      [panelType]="'error'">
    </refx-messages-panel-cont>
    <refx-messages-panel-cont class="ui-error-message-panel"
      [panelType]="'uierror'">
    </refx-messages-panel-cont>
    <refx-messages-panel-cont class="form-error-message-panel"
      [panelType]="'formerrormessage'">
    </refx-messages-panel-cont>
  </div>
  <div mainContent class="challenge-container">
    <div class="challenge-card">
      <h1 class="title refx-display-3" [innerHTML]="((pageTitle$ | async) || '') | o3rTranslate"></h1>
      <o3r-placeholder id="ph-refx-deeplink-challenge-cont-top"></o3r-placeholder>
      <refx-deeplink-challenge-cont
        class="deeplink-challenge-container"
        (onSubmitted)="handleNavigation($event)">
      </refx-deeplink-challenge-cont>
      <o3r-placeholder id="ph-refx-deeplink-challenge-cont-bottom"></o3r-placeholder>
    </div>
  </div>
</refx-basic-layout>
